import { render, staticRenderFns } from "./uploadArquivo.vue?vue&type=template&id=9dbfda46"
import script from "./uploadArquivo.vue?vue&type=script&lang=js"
export * from "./uploadArquivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports